'use strict';

/// <reference path="api.d.ts" />
var API;
(function (API) {
    var Client;
    (function (Client) {})(Client = API.Client || (API.Client = {}));
})(API || (API = {}));